/**
 * @prop --ui-header-content-width: width of the header content
 * @prop --ui-header-content-max-width: max-width of the header content
 * @prop --ui-header-content-padding-top: padding-top of the header content
  * @prop --ui-header-content-padding-bottom: padding-bottom of the header content
  * @prop --ui-header-content-padding-x: padding left and right of the header content
 */

:host {
  display: block;
  z-index: var(--component-ui-header-fixed-z-index, #{$z-index-header});
  position: absolute;
  top: 0;
  left: 0;

  .header {
    width: 100vw;
    background-color: var(--skin-color-white, $ui-white);
    position: relative;
    box-shadow: 0 2px 3px rgba($ui-dark, .45);

    .content {
      position: relative;
      margin: 0 auto;
      width: var(--ui-header-content-width, calc(100vw - 2 * var(--ui-header-content-x-padding, #{$outer-padding})));
      max-width: var(--ui-header-content-max-width);
      // stylelint-disable declaration-block-no-redundant-longhand-properties
      padding-top: var(--ui-header-content-padding-top, var(--ui-header-content-y-padding, 16px));
      padding-right: var(--ui-header-content-padding-x, #{$outer-padding});
      padding-bottom: var(--ui-header-content-padding-bottom, var(--ui-header-content-y-padding, 0));
      padding-left: var(--ui-header-content-padding-x, #{$outer-padding});
      // stylelint-enable declaration-block-no-redundant-longhand-properties
    }
  }
}

:host([fixed]) {
  position: fixed;
}
